import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { StingrayAuthenticationService } from '@app/core/authentication/stingray-authentication.service';
import { CostHitAllowed } from '@app/core/stingray-api/models';
import { OrganizationsService } from '@app/core/stingray-api/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'unite-costs-hit-reached',
    templateUrl: './costs-hit-reached.component.html',
    styleUrls: ['./costs-hit-reached.component.scss'],
    imports: [TranslateModule]
})
export class CostsHitReachedComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  costHitAllowed: CostHitAllowed;
  
  constructor(
    private organizationsService: OrganizationsService,
    private stingrayAuthenticationService: StingrayAuthenticationService) {
  }

  ngOnInit(): void {
    this.getCostHitAllowed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  public getCostHitAllowed(): Observable<boolean> {
    return new Observable(obs => {
      this.organizationsService.getCostHitAllowed({ id: this.stingrayAuthenticationService.organizationId })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(c => {
          this.costHitAllowed = c;
          obs.next(c.allowed);
          obs.complete();
        });
    });
  }
}
